import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MeetList, MeetScoreReport } from '@athleticnet/athletic-live-api-models';
import { NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { ScoresDashletTableGridComponent } from '../scores-dashlet-table-grid/scores-dashlet-table-grid.component';

@Component({
  selector: 'app-scores-dashlet',
  imports: [CommonModule, NgbNavModule, ScoresDashletTableGridComponent],
  templateUrl: './scores-dashlet.component.html',
  styleUrls: ['./scores-dashlet.component.scss'],
})
export class ScoresDashletComponent {
  @ViewChild('nav') nav!: NgbNav; // Get a reference to the ngbNav
  @Input() currentMeet!: MeetList;
  activeTab!: string;

  constructor(private router: Router) {}

  async goToScore(scoreId: any) {
    await this.router.navigate(['meets', this.currentMeet.id, 'track-scores', scoreId]);
  }

  getScore(meetScoreItem: MeetScoreReport['meetScores'][0]): string {
    if (!meetScoreItem) {
      return '';
    }

    if (meetScoreItem.projectedScore) {
      return `${meetScoreItem.score} (Proj: ${meetScoreItem.projectedScore})`;
    }

    return `${meetScoreItem.score}`;
  }
}
